import { render, staticRenderFns } from "./ProductRestockIframe.vue?vue&type=template&id=0af7e8b4&"
import script from "./ProductRestockIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductRestockIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports